// src/pages/PaymentSuccess.js
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { trackEvent } from '../analytics';

function PaymentSuccess() {
    useEffect(() => {
        trackEvent('checkout_success');
    }, []);
    return (
        <div className="payment-result-page">
            <h2>Payment Successful!</h2>
            <p>Thank you for subscribing to Compliance Guardian. Your subscription is now active.</p>
            <p>You can now run compliance audits and access all features.</p>
            <Link to="/" className="button">Go to Dashboard</Link>
        </div>
    );
}

export default PaymentSuccess;
